<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      width="90%"
      scrollable
      @keydown="executeCloseModalSignContract"
      @click:outside="executeCloseModalSignContract"
    >
      <v-card>
        <div class="p-3 pb-0">
          <v-tabs fixed-tabs centered v-model="tab" active-class="bg-primary">
            <v-tab
              id="fiabilityData"
              class="tab-list"
              key="fiabilityData"
              active-class="bg-app-primary text-white rounded"
              >Fiabilidad de los Datos</v-tab
            >
            <v-tab
              @click="setDocumentsToCompare(documentsToPreview)"
              id="previewDocuments"
              class="tab-list"
              active-class="bg-app-primary text-white rounded"
              key="previewDocuments"
              >Comparar Documentos</v-tab
            >
            <v-tab
              id="attachDocuments"
              class="tab-list"
              active-class="bg-app-primary text-white rounded"
              key="attachDocuments"
              >{{
                onlyReadContract
                  ? "Resumen de información enviada"
                  : "Anexar Documentos"
              }}</v-tab
            >
          </v-tabs>
        </div>
        <hr class="mb-2" />
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item key="fiabilityData">
              <section class="text-center" v-if="loadingValidation">
                <v-progress-circular
                  class="mx-auto text-center my-5"
                  indeterminate
                  color="primary"
                  size="50"
                ></v-progress-circular>
                <h4 class="text-center my-3">
                  Obteniendo fiabilidad de los datos
                </h4>
                <p class="text-center">
                  Por favor espere...
                </p>
              </section>
              <v-form
                @submit.prevent="resendDataClientManually"
                v-if="!loadingValidation"
              >
                <p
                  :class="
                    `${
                      onlyReadContract ? 'text-success' : 'text-info'
                    } text-center mt-8`
                  "
                >
                  <v-icon
                    small
                    :color="onlyReadContract ? 'success' : 'info'"
                    class="mr-2"
                  >
                    mdi-information-outline
                  </v-icon>
                  <b v-if="!onlyReadContract">IMPORTANTE:</b>
                  {{
                    onlyReadContract
                      ? "Datos enviados a WebDox"
                      : "En caso de haber error en los datos, puede modificarlos manualmente en el siguiente formulario"
                  }}
                </p>
                <v-row
                  align-content="center"
                  justify="center"
                  class="mt-5 w-50 mx-auto"
                >
                  <v-col cols="12" md="12" sm="12">
                    <span
                      class=""
                      v-if="
                        dataValidationDocuments &&
                          dataValidationDocuments.persona_cliente
                      "
                    >
                      <v-icon
                        small
                        :color="
                          dataValidationDocuments.persona_cliente.nombre.status
                            ? 'success'
                            : 'error'
                        "
                      >
                        {{
                          dataValidationDocuments.persona_cliente.nombre.status
                            ? "mdi-check-circle"
                            : "mdi-close-circle"
                        }}
                      </v-icon>
                      <b>
                        {{
                          dataValidationDocuments.persona_cliente.nombre.status
                            ? "El Nombre del Cliente coincide en los documentos"
                            : dataValidationDocuments.persona_cliente.nombre
                                .comment
                        }}
                      </b>
                    </span>
                    <v-text-field
                      :disabled="onlyReadContract"
                      class="mt-5"
                      label="Nombre del Cliente"
                      placeholder="Ingresa el Nombre del Cliente"
                      v-model="$v.form.client_name.$model"
                      :error="$v.form.client_name.$invalid && submitUpload"
                      :error-messages="
                        $v.form.client_name.$invalid && submitUpload
                          ? 'Este campo es requerido'
                          : null
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" sm="12">
                    <span
                      class=""
                      v-if="
                        dataValidationDocuments &&
                          dataValidationDocuments.persona_cliente
                      "
                    >
                      <v-icon
                        small
                        :color="
                          dataValidationDocuments.persona_cliente.rut.status
                            ? 'success'
                            : 'error'
                        "
                      >
                        {{
                          dataValidationDocuments.persona_cliente.rut.status
                            ? "mdi-check-circle"
                            : "mdi-close-circle"
                        }}
                      </v-icon>
                      <b>
                        {{
                          dataValidationDocuments.persona_cliente.rut.status
                            ? "El RUT coincide en los documentos"
                            : dataValidationDocuments.persona_cliente.rut
                                .comment
                        }}
                      </b>
                    </span>
                    <v-text-field
                      :disabled="onlyReadContract"
                      class="mt-5"
                      label="RUT del Cliente"
                      placeholder="Ingresa el RUT del cliente"
                      @keypress="validateRutFormat"
                      @paste="
                        validateRutFormat($event);
                        formatRut();
                      "
                      v-model="form.client_rut"
                      :error="
                        $v.form.client_rut.$invalid &&
                          $v.form.client_rut.$model !== null
                      "
                      :error-messages="
                        $v.form.client_rut.$invalid && $v.form.client_rut.$model
                          ? 'El RUT ingresado no es válido'
                          : null
                      "
                      @input="formatRut"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" sm="12">
                    <span
                      class=""
                      v-if="
                        dataValidationDocuments &&
                          dataValidationDocuments.persona_cliente
                      "
                    >
                      <v-icon
                        small
                        :color="
                          dataValidationDocuments.persona_cliente.email.status
                            ? 'success'
                            : 'error'
                        "
                      >
                        {{
                          dataValidationDocuments.persona_cliente.email.status
                            ? "mdi-check-circle"
                            : "mdi-close-circle"
                        }}
                      </v-icon>
                      <b>
                        {{
                          dataValidationDocuments.persona_cliente.email.status
                            ? "El Correo Electrónico coincide en los documentos"
                            : dataValidationDocuments.persona_cliente.email
                                .comment
                        }}
                      </b>
                    </span>
                    <v-text-field
                      :disabled="onlyReadContract"
                      class="mt-5"
                      label="Correo Electrónico del Cliente"
                      placeholder="Ingresa el Correo Electrónico del Cliente"
                      v-model="$v.form.client_email.$model"
                      :error="$v.form.client_email.$invalid && submitUpload"
                      :error-messages="
                        $v.form.client_email.$invalid && submitUpload
                          ? 'Este campo es requerido'
                          : null
                      "
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-tab-item>
            <v-tab-item key="previewDocuments">
              <preview-documents-side-a-side
                ref="previewDocumentsSideAside"
                :onlyReadContract="onlyReadContract"
              ></preview-documents-side-a-side>
            </v-tab-item>
            <v-tab-item key="attachDocuments" class="px-5">
              <v-row align-content="center" justify="center" class="mt-5">
                <h4 class="text-center mb-8">
                  <v-icon color="success" class="ml-1" small>
                    mdi-check-circle-outline
                  </v-icon>
                  Resumen con la Información
                  {{ onlyReadContract ? "enviada" : "a enviar" }}
                </h4>
                <v-col cols="12" md="4" sm="12" align-self="start">
                  <section class="text-center">
                    <h5>1. Documentos obligatorios Adjuntos</h5>
                    <v-list flat subheader three-line class="ml-1">
                      <v-list-item class="mt-5">
                        <v-list-item-content>
                          <v-list-item-title class="mb-0">
                            <v-icon small class="text-primary">
                              mdi-file-document-outline
                            </v-icon>
                            <span class="mt-2 font-weight-bold">
                              Contrato
                            </span>
                          </v-list-item-title>
                          <small>
                            <span class="">
                              Área Responsable:
                            </span>
                            <span class="mx-1">
                              Comercial
                            </span>
                          </small>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="">
                        <v-list-item-content>
                          <v-list-item-title class="mb-0">
                            <v-icon small class="text-primary">
                              mdi-file-document-outline
                            </v-icon>
                            <span class="mt-2 font-weight-bold">
                              Cédula de identidad
                            </span>
                          </v-list-item-title>
                          <small>
                            <span class="">
                              Área Responsable:
                            </span>
                            <span class="mx-1">
                              Comercial
                            </span>
                          </small>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </section>
                </v-col>
                <v-col cols="12" md="4" sm="12" align-self="start">
                  <section class="text-center">
                    <h5>
                      2. Datos del Cliente
                    </h5>
                    <v-list flat subheader two-line class="mt-8">
                      <v-list-item class="my-2">
                        <v-list-item-title class="d-flex flex-column">
                          <span class="text-body-2">
                            <v-icon color="primary" small>
                              mdi-account-outline
                            </v-icon>
                            Nombre del Cliente:
                          </span>
                          <span class="text-body-2 mt-2 font-weight-bold">
                            {{ form.client_name }}
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="my-2">
                        <v-list-item-title class="d-flex flex-column">
                          <span class="text-body-2">
                            <v-icon color="primary" small>
                              mdi-account-box-outline
                            </v-icon>
                            RUT del Cliente:
                          </span>
                          <span class="text-body-2 mt-2 font-weight-bold">
                            {{ form.client_rut }}
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="my-2">
                        <v-list-item-title class="d-flex flex-column">
                          <span class="text-body-2">
                            <v-icon color="primary" small>
                              mdi-email-outline
                            </v-icon>
                            Email del Cliente:
                          </span>
                          <span class="text-body-2 mt-2 font-weight-bold">
                            {{ form.client_email }}
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </section>
                </v-col>
                <v-col cols="12" md="4" sm="12" v-if="!onlyReadContract">
                  <section class="text-center w-75">
                    <h5>
                      3. Documentos A Anexar (Opcional)
                    </h5>
                    <label for="" class="mt-5 font-weight-bold text-center">
                      Selecciona un máximo de 2 documentos para anexar
                      (Opcional)</label
                    >
                    <v-autocomplete
                      v-model="form.documentsToAnnex"
                      :items="
                        folderSaleResidentialSctructureWithContractAndIdentityCard
                      "
                      chips
                      item-text="document_type.name"
                      item-value="id"
                      clearable
                      searchable
                      placeholder="Seleccionar documentos"
                      multiple
                      no-data-text="Sin documentos para anexar"
                    ></v-autocomplete>
                  </section>
                </v-col>
              </v-row>
              <v-btn
                v-if="!onlyReadContract"
                :disabled="!formContractIsReady"
                @click="signContract"
                class="float-right primary text-white"
              >
                <v-icon small class="mr-2">
                  mdi-send
                </v-icon>
                Enviar a Firmar Contrato
              </v-btn>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalSignContract"
          >
            <small> {{ onlyReadContract ? "Cerrar" : "Cancelar" }} </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { mapActions, mapGetters } from "vuex";
import {
  NAME_FOLDER_SALE_RESIDENTIAL,
  NAME_FILE_CONTRACT,
  NAME_FILE_IDENTITY_CARD,
} from "@/constants/presale";
import { email, required } from "vuelidate/lib/validators";
import { formatToChileanRut, validateRut, rutValid } from "@/helpers/rut";
import PreviewDocumentsSideASide from "./PreviewDocumentsSideASide.vue";

export default {
  components: { PreviewDocumentsSideASide },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalSignContract: {
      type: Function,
      default: () => {},
    },
    currentPresale: {
      default: null,
    },
    onlyReadContract: {
      type: Boolean,
      default: false,
    },
  },
  validations() {
    return {
      form: {
        client_rut: { required, rutValid },
        client_email: { required, email },
        client_name: { required },
      },
    };
  },
  data() {
    return {
      documentsToPreview: [],
      form: {
        documentsToAnnex: [],
        client_name: "",
        client_rut: "",
        client_email: "",
      },
      submitUpload: false,
      tab: "fiabilityData",
      loading: false,
      loadingValidation: false,
      dataValidationDocuments: null,
    };
  },
  methods: {
    validateRut,
    ...mapActions({
      validateDocumentsPresale: "presale/validateDocumentsPresale",
      getWebdoxDocuments: "presale/getWebdoxDocuments",
      sendWebdoxDocuments: "presale/sendWebdoxDocuments",
    }),
    setDocumentsToCompare(documentsToCompare) {
      this.documentsToPreview = documentsToCompare;
      setTimeout(() => {
        if (this.$refs.previewDocumentsSideAside) {
          this.$refs.previewDocumentsSideAside.setDocumentsToCompare(
            documentsToCompare
          );
        }
      }, 200);
    },
    executeCloseModalSignContract($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        if (this.$refs.previewDocumentsSideAside) {
          this.$refs.previewDocumentsSideAside.resetDocumentsToPreview();
        }
        this.showFormClientData = false;
        this.closeModalSignContract($event);
      }
    },
    formatRut() {
      this.form.client_rut = formatToChileanRut(this.form.client_rut);
    },
    validateRutFormat(event) {
      const allowedCharacters = /[0-9.\-K]/i; // Permite números, punto, guión y "K" (mayúscula o minúscula)
      let textToValidate = event.key
        ? event.key
        : event.clipboardData.getData("text");

      if (!allowedCharacters.test(textToValidate)) {
        event.preventDefault();
      } else {
        if (!event.key) {
          this.formatRut();
        }
      }
    },
    async resendDataClientManually() {
      this.submitUpload = true;

      if (!this.$v.form.$invalid) {
        this.loading = true;
        const resp = await this.validateDocumentsPresale({
          cedula_id: this.documentIdentityCard[0].documents[0].id,
          cedula_url: this.documentIdentityCard[0].documents[0].url,
          contrato_id: this.documentContract[0].documents[0].id,
          contrato_url: this.documentContract[0].documents[0].url,
          pre_project_id: this.$route.query.presale_code,
          client_name: this.form.client_name,
          client_rut: this.form.client_rut,
          client_email: this.form.client_email,
        });

        if (resp.status == 200 || resp.status == 201) {
          this.$swal.fire({
            icon: "success",
            title: "Excelente",
            text: `Datos de cliente enviados correctamente`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.submitUpload = false;
          this.dataValidationDocuments = resp.data;
        }

        if (resp.status == 500) {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Ha ocurrido un error en el servidor, intenta nuevamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }

        if (resp.status == 400 || resp.status == 422) {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    async sendGetWebdoxDocuments(documentId) {
      const resp = await this.getWebdoxDocuments({
        contrato_id: documentId,
      });
      if (resp && resp.status == 200 && resp.data && resp.data.data) {
        this.dataValidationDocuments = resp.data.data;
        this.setFormClientData(this.dataValidationDocuments);
      }
    },
    setFormClientData(data) {
      this.form.client_name = data.client_name;
      this.form.client_rut = data.client_rut;
      this.form.client_email = data.client_email;
    },
    async sendValidateDocumentsPresale() {
      if (!this.dataValidationDocuments) {
        this.loadingValidation = true;
        const resp = await this.validateDocumentsPresale({
          cedula_id: this.documentIdentityCard[0].documents[0].id,
          cedula_url: this.documentIdentityCard[0].documents[0].url,
          contrato_id: this.documentContract[0].documents[0].id,
          contrato_url: this.documentContract[0].documents[0].url,
          pre_project_id: this.$route.query.presale_code,
        });
        if (
          !resp ||
          resp.status == 500 ||
          resp.status == 429 ||
          resp.status == 422
        ) {
          this.loadingValidation = false;
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text:
              "Ha ocurrido un error al intentar validar los documentos, ingresa manualmente los datos",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
        if (resp && resp.data) {
          this.dataValidationDocuments = resp.data;
          this.setFormClientData({
            client_name: this.dataValidationDocuments?.persona_cliente?.nombre
              ?.value,
            client_rut: this.dataValidationDocuments?.persona_cliente?.rut
              ?.value,
            client_email: this.dataValidationDocuments?.persona_cliente?.email
              ?.value,
          });
        } else {
          this.dataValidationDocuments = null;
        }
        this.loadingValidation = false;
      }
    },
    async signContract() {
      if (
        !this.form.client_name ||
        !this.form.client_rut ||
        !this.form.client_email
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            "Debe completar todos los campos en la pestaña de fiabilidad de los datos",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      this.submitUpload = true;
      if (!this.$v.form.$invalid) {
        this.loading = true;
        let self = this;
        const resp = await this.sendWebdoxDocuments({
          contrato_id: this.documentContract[0].documents[0].id,
          cedula_id: this.documentIdentityCard[0].documents[0].id,
          titulo: `Contrato de Preventa ${this.$route.query.presale_code}`,
          descripcion: `Contrato de Preventa ${this.$route.query.presale_code}`,
          pre_project_id: this.$route.query.presale_code,
          folder_document_type: this.documentContract[0].id,
          cedula_url: this.documentIdentityCard[0].documents[0].url,
          contrato_url: this.documentContract[0].documents[0].url,
          client_name: this.form.client_name,
          client_rut: this.form.client_rut,
          client_email: this.form.client_email,
          entity_client_name: this.dataValidationDocuments?.entidad_cliente
            ?.nombre?.status
            ? this.dataValidationDocuments.entidad_cliente.nombre.value
            : null,
          entity_client_rut: this.dataValidationDocuments?.entidad_cliente?.rut
            ?.status
            ? this.dataValidationDocuments.entidad_cliente.rut.value
            : null,
          entity_client_email: this.dataValidationDocuments?.entidad_cliente
            ?.email?.status
            ? this.dataValidationDocuments.entidad_cliente.email.value
            : null,
          anexos: this.form.documentsToAnnex.length
            ? this.folderSaleResidentialSctructureWithContractAndIdentityCard
                .filter((item) => self.form.documentsToAnnex.includes(item.id))
                .map((item) => {
                  return item.documents[0].url;
                })
            : undefined,
        });

        if (resp.status == 200 || resp.status == 201) {
          this.$swal.fire({
            icon: "success",
            title: "Excelente",
            text: "El contrato fue enviado con éxito a WebDox",
            position: "top-end",
            toast: true,
            timeProgressBar: true,
            showConfirmButton: false,
            timer: 5000,
          });
          this.sendGetWebdoxDocuments(this.documentContract[0].documents[0].id);
          this.closeModalSignContract();
        }

        if (resp.status == 500) {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Ha ocurrido un error en el servidor, intenta nuevamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }

        if (resp.status == 400 || resp.status == 422) {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      } else {
        return this.$swal.fire({
          icon: "warning",
          title: "Atención",
          text:
            "Verifica la pestaña de fiabilidad de los datos para ver los errores",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      documents: "document/documents",
    }),
    folderSaleResidentialSctructureWithContractAndIdentityCard() {
      return this.documents.length
        ? this.documents[0].children
            .find((folder) => folder.name == NAME_FOLDER_SALE_RESIDENTIAL)
            ?.folder_document_types.filter(
              (document_type) =>
                document_type.documents.length &&
                document_type.document_type.name !== NAME_FILE_CONTRACT &&
                document_type.document_type.name !== NAME_FILE_IDENTITY_CARD
            )
        : [];
    },
    documentIdentityCard() {
      return this.documents.length
        ? this.documents[0].children
            .find((folder) => folder.name == NAME_FOLDER_SALE_RESIDENTIAL)
            ?.folder_document_types.filter(
              (document_type) =>
                document_type.documents.length &&
                document_type.document_type.name === NAME_FILE_IDENTITY_CARD
            )
        : [];
    },
    documentContract() {
      return this.documents.length
        ? this.documents[0].children
            .find((folder) => folder.name == NAME_FOLDER_SALE_RESIDENTIAL)
            ?.folder_document_types.filter(
              (document_type) =>
                document_type.documents.length &&
                document_type.document_type.name === NAME_FILE_CONTRACT
            )
        : [];
    },
    formContractIsReady() {
      return this.dataValidationDocuments;
    },
  },
  watch: {
    documents: async function(newValue) {
      if (newValue && newValue.length) {
        if (this.documentContract && this.documentContract.length) {
          this.dataValidationDocuments = null;
          this.sendGetWebdoxDocuments(this.documentContract[0].documents[0].id);
        }
      }
    },
  },
};
</script>

<style></style>
